import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux'

const LiveStatsMenuItems = (props) => {
    function activeItem(url) {
        var regex = new RegExp("^/" + url + "/", "ig");
        return (window.location.href.split('#')[1].match(regex) ? "stats-menu__list-item_active" : "")
    }
    const tree = useSelector(state => state.overviewReducer.customerOverview)
    let companyAdminRoute =  tree.type === "customer"
    console.log("companyAdminRoute", companyAdminRoute)
    return (
        <React.Fragment>
            <Link className="stats-menu__list-item stats-menu__list-item_link" to={props.node.info.hasfloorplan ? `statistic/${props.id}` : null} >
                <span className="font-icon icon-stats" />
                <span className="text">Stats</span>
            </Link>
            <Link className={`stats-menu__list-item ${activeItem("heatmap")} stats-menu__list-item_link`} to={props.node.info.hasfloorplan ? `heatmap/${props.id}` : null} >
                <span className="font-icon icon-heatmap" />
                <span className="text">Heatmap</span>
            </Link>
            <Link className={`stats-menu__list-item ${activeItem("live")} stats-menu__list-item_link`} to={props.node.info.hasfloorplan ? `live/${props.id}` : null} >
                <span className="font-icon icon-live" />
                <span className="text">Live</span>
            </Link>
            {companyAdminRoute &&
                <Link className={`stats-menu__list-item ${activeItem("devicemanagement")} stats-menu__list-item_link`} to={props.node.info.hasfloorplan ? `devicemanagement/${props.id}` : null} >
                    <span className="font-icon icon-devicem" />
                    <span className="text">Device Management</span>
                </Link>
            }
        </React.Fragment>

    );
}
LiveStatsMenuItems.propTypes = {
    node: PropTypes.object.isRequired,
    id: PropTypes.number
}

export default (LiveStatsMenuItems);



// WEBPACK FOOTER //
// ./src/components/common/livestatsmenuitems.jsx